import React from 'react';
import { Spin } from 'antd';
import './DataList.css';

/**
 * What sits under an endless list instead of page numbers: the sentinel that
 * pulls the next page in, and a line saying how far through the reader is.
 *
 * Pair with useInfinitePages, which owns the sentinel and the fetching.
 */
const InfiniteFoot = ({
    sentinelRef,
    loading,
    loaded,
    total,
    hasMore,
    noun = 'item',
    plural,
    className,
    dataCy = 'list-foot',
}: {
    sentinelRef: React.RefObject<HTMLDivElement>;
    loading: boolean;
    /** how many records are on screen */
    loaded: number;
    /** how many the server says there are */
    total: number;
    hasMore: boolean;
    noun?: string;
    plural?: string;
    className?: string;
    dataCy?: string;
}) => {
    const many = plural ?? `${noun}s`;

    return (
        <div className={`dl-foot${className ? ` ${className}` : ''}`} data-cy={dataCy}>
            <div ref={sentinelRef} className="dl-foot__sentinel" aria-hidden="true" />
            {loaded > 0 && (
                <span className="dl-foot__status" role="status" aria-live="polite">
                    {loading ? (
                        <>
                            <Spin size="small" />
                            Loading more…
                        </>
                    ) : (
                        hasMore
                            ? `Showing ${loaded} of ${total} ${many}`
                            : `All ${loaded} ${loaded === 1 ? noun : many} loaded`
                    )}
                </span>
            )}
        </div>
    );
};

export default InfiniteFoot;
